import { useEffect, useState, useRef } from 'react'
import { Modal, Table, Space, Button, Input } from 'antd'
import type { ColumnsType } from 'antd/es/table';
import { CloseOutlined, } from '@ant-design/icons';
import style from './index.module.scss'
import { center } from '@antv/x6/lib/registry/node-anchor/bbox';
import * as apis from '../../api/networkDisk'
import useStore from '../../store/useStore'
import { deepCopy } from '../../util';
import Paging from '../../components/pagination'


interface Props {
    visible: any
    onClose: () => void;
    onRefresh: () => void;
    title: any;
}
interface DataType {
    key: React.Key;
    name: string;
}

const Search = (props: Props) => {
    const [selectedRows, setSelectedRows] = useState<any>();
    const [selectedRowKeys, setSelectedRowKeys] = useState<any>();
    const [pageIndex, setPageIndex] = useState<number>(1);
    const [pageSize, setPageSize] = useState<number>(20);
    const [disabled, setDisabled] = useState<boolean>(true);
    const [data, setData] = useState<any>();
    const [total, setTotal] = useState<any>(0);

    const [inputVal, setInputVal] = useState<any>('');

    const inputRef = useRef<any>()
    const { store, dispatch } = useStore();

    useEffect(() => {
        console.log(props.visible, selectedRows)
        if (!props.visible) {
            setTimeout(() => {
                reset()
            }, 200);
        } else {
            // getList() 
        }
    }, [props.visible])
    useEffect(() => {
        // Use a timeout to determine when the user has stopped typing
        const timeoutId = setTimeout(() => {
            getList(inputVal, { index: pageIndex, size: pageSize })
            setSelectedRows([])
            setSelectedRowKeys([])
        }, 500); // Adjust the timeout as needed (e.g., 500 milliseconds)

        // Cleanup function to clear the timeout when the component unmounts or when inputVal changes
        return () => {
            clearTimeout(timeoutId);
        };
    }, [inputVal]);
    const getList = async (content: any, page: any) => {
        try {
            let res: any = await apis.getMemo(store.subjectInfo.subjectId, { content: content, skip: (page.index - 1) * page.size, limit: page.size })
            if (res.ok) {
                let list: any = []
                res.data.list.map((i: any) => {
                    // i.isClamp=false
                    list.push({ ...i, isClamp: false })
                })
                setData(list)
                setTotal(res.data.total)
            }
        } catch (e) { }
    }
    const columns: ColumnsType<DataType> = [
        {
            title: '便签内容',
            key: 'content',
            dataIndex: 'content',
            render: (record: any, info: any, index: any) => {
                return <span data-flex='main:justify'><span className={(!info.isClamp) ? 'clamp1' : ''}
                    style={{ flex: '0 0 calc(100% - 40px)', width: 'calc(100% - 40px)' }}
                    id={'content' + index}>{record}</span>
                    {/* <>{console.log(record.indexOf('…'))}</> */}
                    <>{console.log(info.id, (document as any).getElementById('content' + index)?.scrollWidth, (document as any).getElementById('content' + index)?.offsetWidth)}</>
                    {(document as any).getElementById('content' + index)?.scrollWidth - (document as any).getElementById('content' + index)?.offsetWidth > 0 && <Space size="middle"
                        style={{ flex: '0 0  40px', width: ' 40px' }}>
                        <a onClick={() => {
                            let _data: any = deepCopy(data)
                            console.log(_data)
                            _data.map((i: any) => {
                                if (i.id === info.id) {
                                    i.isClamp = !i.isClamp
                                }
                            })
                            setData(_data)
                        }}>{(info.isClamp) ? '[概要]' : '[详情]'}</a>
                    </Space>
                    }
                </span>
            },
        },
        {
            title: '操作',
            key: 'action',
            width: 100,
            align: 'center',
            render: (_, record) => (
                <Space size="middle">

                    <a onClick={() => {
                        addMemos(record)

                    }}>添加</a>
                </Space>
            ),
        },
    ];
    /**
     * 
     * @param params 保存主题
     */
    const saveSubject = async (params: any, e?: any,) => {
        try {
            let res: any = await apis.putExcellingTopic(params.id, params)
            console.log(e)
            if (res.ok) {
                // dispatch({
                //     type: 'SET_SUBJECTINFO_PART',
                //     data: params
                // });
                getList(inputVal, { index: pageIndex, size: pageSize })
            }
        } catch (e) { }

    }
    const addMemos = (e: any) => {
        console.log(e)
        let params: any = deepCopy(store.subjectInfo?.data)
        params.memos = []
        params.memos = params.memos.concat(e)
        params.$operate$ = 'save'
        let graphInfo: any = localStorage.getItem('things_x6_container')
        let x: any = JSON.parse(graphInfo).x
        let y: any = JSON.parse(graphInfo).y
        console.log(x, y)
        params.memos.map((i: any) => {
            i.$operate$ = 'save'
            i.visible = true
            i.x = x - Math.floor(Math.random() * 70 - 10)
            i.y = y - Math.floor(Math.random() * 70 - 10)
        })
        console.log(params)
        saveSubject(params, e)
        // dispatch({
        //     type: 'SET_SUBJECTINFO',
        //     data: { subjectCatalogue: [], subjectId: resultObj.topicId, data: store.subjectInfo.initData }
        // });
    }
    // const data: DataType[] = [
    //     {
    //         key: '1',
    //         name: 'John Brown',
    //     },
    //     {
    //         key: '2',
    //         name: 'Jim Green',
    //     },
    //     {
    //         key: '3',
    //         name: 'Joe Black',
    //     },
    //     {
    //         key: '4',
    //         name: 'Disabled User',
    //     },
    // ];

    /**
  * @name 重置
  */
    const reset = () => {

        setTotal(0)
        setData([])
        setSelectedRows([])
        setSelectedRowKeys([])

        console.log(inputRef.current)
        setInputVal('')
        setDisabled(true)
        // inputRef.current.setValue('')
    }

    const rowSelection = {
        onChange: (selectedRowKeys: React.Key[], selectedRows: DataType[]) => {
            console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
            setSelectedRows(selectedRows)
            selectedRowKeys?.length > 0 ? setDisabled(false) : setDisabled(true)

        },
        getCheckboxProps: (record: DataType) => ({
            disabled: record.name === 'Disabled User', // Column configuration not to be checked
            name: record.name,
        }),
    };

    return (
        <Modal
            centered
            footer={null}
            closable={false}
            width={'600px'}
            title={props.title}
            open={props.visible}>
            <div>
                <div data-flex='main:justify cross:center' className='mb-40 pos-r'>
                    <div className='mr-20 wp-100'>
                        <Input className='input' value={inputVal} ref={inputRef} placeholder="请输入搜索内容" allowClear onChange={(e) => {
                            if (!e.target.value && e.type !== 'change') {
                                // do something
                                console.log('llll')
                                reset()
                            }
                            if (!e.target.value) {
                                reset()
                            } else {

                                setInputVal(e.target.value)
                            }
                        }} /></div>
                    <CloseOutlined onClick={() => { props.onClose() }} />
                    <div className={style.result}>{total}条搜索结果</div>
                </div>
                <Table
                    rowSelection={{
                        type: 'checkbox',
                        ...rowSelection,
                    }}
                    key={inputVal}
                    rowKey='id'
                    pagination={false}
                    columns={columns}
                    dataSource={data}
                    scroll={{ y: '39vh' }}
                />
                <Paging current={pageIndex} total={total} onRefresh={(index: any, size: any) => {
                    setPageIndex(index)
                    setPageSize(size)
                    getList(inputVal, { index: index, size: size })

                }} />
                <div data-flex='main:justify' className='mt-20'>
                    <div> {selectedRows?.length > 0 && <div dangerouslySetInnerHTML={{
                        __html: `已选:<a>${selectedRows?.length}</a>`
                    }}
                    />}</div>
                    <Button type="primary" key="look" disabled={disabled} onClick={(e) => {
                        e.stopPropagation();
                        addMemos(selectedRows)
                        setTimeout(() => {
                            props.onClose()
                        }, 500);
                    }} >
                        确认添加
                    </Button>
                </div>

            </div>
        </Modal>
    )
}

export default Search